import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import toast from 'react-hot-toast';
import { getCart, saveCart, addToCart as utilsAddToCart, removeFromCart as utilsRemoveFromCart, updateCartItemQuantity as utilsUpdateQuantity, clearCart as utilsClearCart, getCartItemCount } from '../utils/cart';

export const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      total: 0,
      addItem: (product, quantity = 1) => {
        const updatedCart = utilsAddToCart(product, quantity);
        set({ items: updatedCart.items, total: updatedCart.total });
        toast.success('Added to cart!');
      },
      removeItem: (productId) => {
        const updatedCart = utilsRemoveFromCart(productId);
        set({ items: updatedCart.items, total: updatedCart.total });
        toast.success('Removed from cart');
      },
      updateQuantity: (productId, quantity) => {
        const updatedCart = utilsUpdateQuantity(productId, quantity);
        set({ items: updatedCart.items, total: updatedCart.total });
      },
      clearCart: () => {
        const updatedCart = utilsClearCart();
        set({ items: updatedCart.items, total: updatedCart.total });
      },
      getItemCount: () => {
        return getCartItemCount();
      },
    }),
    {
      name: 'shophub_cart',
      partialize: (state) => ({
        items: state.items,
        total: state.total,
      }),
    }
  )
);